module.exports = __webpack_public_path__ + "img/switaly_entertraining_logo.28f4de7b.png";